export default "__VITE_ASSET__CJKpyJQ3__"